import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';
import MultiTextFieldComponent from '@components/inputs/multiTextField/MultiTextField.component';
import React from 'react';
import {Stack} from '@mui/material';
import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';

type MultiInputColumnComponentProps = GridRenderEditCellParams

const MultiInputColumnComponent = (props: MultiInputColumnComponentProps) => {
  const {id, field, value} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <MultiTextFieldComponent
        placeholder="-"
        handleChange={(newValue) => {
          console.log('NEW VALUE', newValue);
          apiRef.current.setEditCellValue({id, field, value: newValue || []});
        }}
        values={value ?? []}/>
    </Stack>
  );
};

export const COLUMN_TYPE_MULTI_INPUT = (props: ColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  flex: props.fullWidth ? 1 : undefined,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: true,
  renderCell: (params) => {
    return (
      <Stack flex={1}>
        <MultiTextFieldComponent
          readOnly
          placeholder="-"
          values={params.value || []}/>
      </Stack>
    );
  },
  renderEditCell: (params) => {
    return (
      <MultiInputColumnComponent {...params}/>
    );
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
